// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"0f4cd0fc","250":"cbdd9a9a","292":"7993c137","426":"ffece734","507":"6923c854","532":"719bad6e","572":"8f49e8ba","631":"92d8b232","688":"f71d46b8","834":"9186b904","873":"392f3b31","876":"36d70df4"}[chunkId] + ".chunk.js";
};